cookieInfo = {
	init() {
		if (planb.isMobileApp)
			$('.js-cookieinfo-parent').remove();

		else {
			$('.js-cookieinfo').on('click', function() {
				$('.js-cookieinfo-parent').fadeOut(250, function() {
					$.cookie('BX_COOKIEINFO', true, {path: '/'});
					$(this).remove();
				});
			});

		}
	}
}



$(document).ready(function() {
	cookieInfo.init();
});